
const config = {
  env: isProd() ? 'production' : 'develop',
  apiHost: getApiHost(),
};

function getApiHost() {
  // if (isProd()) {
  return 'https://gw.gzh.qq.com/sidip/site/role/';
  // }

  // return 'https://test.gzh.qq.com/sidip/site/role/';
}

function isProd() {
  return true;
}

export default config;
